import { AddNewProduct } from '@/models/add-new-product/add-new-product';
import { CategoryDetails } from '@/models/category-details/category-details';
import { ImageDetails } from '@/models/image-details/image-details';
import { Component, OnInit } from '@angular/core';
import { FormArray, FormGroup, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AppService } from '@services/app.service';
import { ConfigService } from '@services/config.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';
import Swal from 'sweetalert2'

@Component({
  selector: 'app-create-bosch-product',
  templateUrl: './create-bosch-product.component.html',
  styleUrl: './create-bosch-product.component.scss'
})

export class CreateBoschProductComponent implements OnInit {
  dropdownList = [];
  sizeList = [];
  selectedItemsDepotNumber = [];
  dropdownSettings = {};
  forms: any[] = [];
  mainImage: string | null = null;
  mainImageShow: boolean = false;
  imageList: ImageDetails[] = [];
  mainImageId: number = 0;
  description: string = "";
  categoryDetails: CategoryDetails[] = [];
  currentCategoryId: number = 0;
  productId: number = 0;
  destroy$: Subject<boolean> = new Subject<boolean>();
  CurrentProductDetails: AddNewProduct;
  endPoint: string = "";
  isUpdate: boolean = false;
  editorModules = {
    toolbar: [
      [{ 'header': ['4', '5', '6'] }, { 'font': [] }],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'align': [] }],
      [{ 'color': [] }, { 'background': [] }],
      ['clean']
    ]
  };
  constructor(private toastr: ToastrService, private appService: AppService, private spinner: NgxSpinnerService,
    private configService: ConfigService, private router: Router
  ) {
  }

  newProduct = new UntypedFormGroup({
    productId: new UntypedFormControl('', [Validators.required, Validators.nullValidator]),
    productName: new UntypedFormControl('', [Validators.required, Validators.nullValidator]),
    productCode: new UntypedFormControl('', [Validators.required, Validators.nullValidator]),
    description: new UntypedFormControl('', [Validators.required, Validators.nullValidator]),
    price: new UntypedFormControl('', [Validators.required, Validators.nullValidator]),
    mrp: new UntypedFormControl('', [Validators.required, Validators.nullValidator]),
    gst: new UntypedFormControl('', [Validators.required, Validators.nullValidator]),
    landingPrice: new UntypedFormControl('', [Validators.required, Validators.nullValidator]),
    srp: new UntypedFormControl('', [Validators.required, Validators.nullValidator]),
    shopId: new UntypedFormControl(1, [Validators.required, Validators.nullValidator]),
    availability: new UntypedFormControl('Yes', [Validators.required, Validators.nullValidator]),
    totalQuantity: new UntypedFormControl('', [Validators.required, Validators.nullValidator]),
    categoryId: new UntypedFormControl("", [Validators.required, Validators.nullValidator]),
    createdAt: new UntypedFormControl(0, [Validators.required, Validators.nullValidator]),
    createdBy: new UntypedFormControl('', [Validators.required, Validators.nullValidator]),
    updatedAt: new UntypedFormControl('', [Validators.required, Validators.nullValidator]),
    tempCategoryName: new UntypedFormControl('', [Validators.required, Validators.nullValidator]),

    modelNumber: new UntypedFormControl('', [Validators.required, Validators.nullValidator]),
    powerSource: new UntypedFormControl('', [Validators.required, Validators.nullValidator]),
    ratedInputPower: new UntypedFormControl('', [Validators.required, Validators.nullValidator]),
    voltage: new UntypedFormControl('', [Validators.required, Validators.nullValidator]),
    speedSettings: new UntypedFormControl('', [Validators.required, Validators.nullValidator]),
    noLoadSpeed: new UntypedFormControl('', [Validators.required, Validators.nullValidator]),
    weightKg: new UntypedFormControl('', [Validators.required, Validators.nullValidator]),
    dimensions: new UntypedFormControl('', [Validators.required, Validators.nullValidator]),
    drillingDiameterSteel: new UntypedFormControl('', [Validators.required, Validators.nullValidator]),
    drillingDiameterWood: new UntypedFormControl('', [Validators.required, Validators.nullValidator]),
    includedAccessories: new UntypedFormControl('', [Validators.required, Validators.nullValidator]),
    warrantyMonths: new UntypedFormControl('', [Validators.required, Validators.nullValidator]),

    // productVariantDetails: new FormArray([]),
    imageDetails: new UntypedFormControl('', [Validators.required, Validators.nullValidator]),
  })


  public newProductError = {
    productName: '',
    productCode: '',
    description: '',
    tempCategoryName: '',
    mrp: '',
    gst: '',
    landingPrice: '',
    srp: '',
    totalQuantity: '',
  }

  ngOnInit() {
    this.isUpdate = false;
    this.sizeList = [
      { id: 1, label: "XS" },
      { id: 2, label: "S" },
      { id: 3, label: "M" },
      { id: 4, label: "L" },
      { id: 5, label: "XL" },
      { id: 6, label: "XXL" }
    ];
    this.getCategoryDetails();
    this.productId = Number(localStorage.getItem('productId'));
    if (this.productId === undefined || this.productId === 0) {
      this.addVariant();
    }
    else {
      this.isUpdate = true;
      this.endPoint = this.configService.getConfig().END_POINT;
      this.getProductById();
    }
  }

  get productVariantDetails() {
    return this.newProduct.get('productVariantDetails') as FormArray;
  }


  // Add New Variant
  addVariant() {
    const productIdControl = this.isUpdate
      ? new UntypedFormControl(this.productId, [Validators.required])
      : new UntypedFormControl(0, [Validators.required]);
    const variantGroup = new UntypedFormGroup({
      productId: productIdControl,
      productVariantId: new UntypedFormControl(0, [Validators.required]),
      color: new UntypedFormControl('#000000', [Validators.required]),
      // size: new UntypedFormControl('', [Validators.required]),
      varientQuantity: new UntypedFormControl("", [Validators.required, Validators.min(1)]),
      productMrp: new UntypedFormControl('', [Validators.required]),
      productSrp: new UntypedFormControl('', [Validators.required]),
      varientAdditionalPrice: new UntypedFormControl(0, [Validators.required]),
      isAvailable: new UntypedFormControl(true, [Validators.required]),
      createdAt: new UntypedFormControl(0, [Validators.required]),
      updatedAt: new UntypedFormControl(0, [Validators.required]),
    });

    this.productVariantDetails.push(variantGroup);
  }

  //Get all category details
  getCategoryDetails() {
    this.spinner.show();
    this.appService.getAllCategoryDetails()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        this.spinner.hide();
        console.log("getDeatils", data)
        this.categoryDetails = data;
      }, (error: any) => {
        this.spinner.hide();
        this.toastr.error(error.error.message || "Something Went wrong, please try again...")
      })
  }

  onSelectCategory(event: any) {
    const value = event.target.value;
    const currentDetails = this.categoryDetails.filter(c => c.categoryName === value)
    this.currentCategoryId = Number(currentDetails[0].categoryId);
  }

  // Remove Variant
  removeVariant(index: number, form: any) {
    console.log("removeVariant", index, form);
    if (!this.isUpdate) {
      this.productVariantDetails.removeAt(index);
    } else {
      this.deleteProductVariantDetails(index, form);
    }
  }

  // Dynamically Set Values for a Specific Variant
  setVariantValues(index: number, values: any) {
    if (this.productVariantDetails.controls[index]) {
      this.productVariantDetails.controls[index].setValue(values);
    }
  }

  onSubmit() {
    this.formValidation();
  }

  formValidation() {
    this.newProductError.productName = "";
    this.newProductError.productCode = "";
    this.newProductError.description = "";
    this.newProductError.tempCategoryName = "";
    let hasError = false;

    // Validate Product Name
    if (this.newProduct.get('productName')?.invalid) {
      this.newProductError.productName = "Product Name is required";
      hasError = true;
    }

    // Validate Product Code
    if (this.newProduct.get('productCode')?.invalid) {
      this.newProductError.productCode = "Product Code is required";
      hasError = true;
    }

    // Validate Description
    if (this.newProduct.get('description')?.invalid) {
      this.newProductError.description = "Description is required";
      hasError = true;
    }

    // Vaildate Category Name[]
    if (this.newProduct.get('tempCategoryName')?.invalid) {
      this.newProductError.tempCategoryName = "Category Name is required"
      hasError = true;
    }

    // Validate Product Variants
    // if (this.productVariantDetails.length === 0) {
    //   this.toastr.error("At least one product variant is required.");
    //   hasError = true;
    // } else {
    //   this.productVariantDetails.controls.forEach((variant, index) => {
    //     if (variant.invalid) {
    //       this.toastr.error(`Variant ${index + 1} has missing or invalid fields.`);
    //       hasError = true;
    //     }
    //   });
    // }

    // Validate Image Upload
    if (this.imageList.length < 2 || this.imageList.length > 6) {
      this.toastr.error("Please upload a minimum of 2 images and a maximum of 6 images.");
      hasError = true;
    }

    //Set main image function
    if (this.mainImage == null) {
      console.log(this.mainImage)
      this.toastr.error("Please select a main image");
      hasError = true;
    }

    if (!hasError) {
      console.log(this.newProduct.value);
      if (!this.isUpdate) {
        this.saveProductDetails();
      } else {
        this.updateProductDetails();
      }
    }
  }

  getProductById() {
    this.spinner.show();
    this.appService.getProductIdByDetails(this.productId)
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        this.spinner.hide();
        console.log("getDetails", data)
        this.CurrentProductDetails = data;
        this.currentCategoryId = data.categoryId;
        this.setValueFunction();
      }, (error: any) => {
        this.spinner.hide();
        this.toastr.error(error.error.message || "Something Went wrong, please try again...")
      })
  }

  setValueFunction() {
    this.newProduct.controls['productName'].setValue(this.CurrentProductDetails.productName);
    this.newProduct.controls['productCode'].setValue(this.CurrentProductDetails.productCode);
    this.newProduct.controls['description'].setValue(this.CurrentProductDetails.description);
    this.newProduct.controls['availability'].setValue(this.CurrentProductDetails.availability);
    this.newProduct.controls['productId'].setValue(this.CurrentProductDetails.productId);
    this.newProduct.controls['createdAt'].setValue(this.CurrentProductDetails.createdAt);
    this.newProduct.controls['createdBy'].setValue(this.CurrentProductDetails.createdBy);
    this.imageList = this.CurrentProductDetails.imageDetails;
    this.newProduct.controls['tempCategoryName'].setValue(this.CurrentProductDetails.categoryDetails.categoryName);
    this.CurrentProductDetails.productVariantDetails.forEach((item) => {
      const variantGroup = new UntypedFormGroup({
        productVariantId: new UntypedFormControl(item.productVariantId),
        productId: new UntypedFormControl(item.productId),
        color: new UntypedFormControl(item.color),
        size: new UntypedFormControl(item.size),
        varientQuantity: new UntypedFormControl(item.varientQuantity),
        productMrp: new UntypedFormControl(item.productMrp),
        productSrp: new UntypedFormControl(item.productSrp),
        varientAdditionalPrice: new UntypedFormControl(item.varientAdditionalPrice),
        isAvailable: new UntypedFormControl(item.isAvailable),
        createdAt: new UntypedFormControl(item.createdAt),
      });
      this.productVariantDetails.push(variantGroup);
    });
    const image = this.imageList.find(image => image.isPrimary == true);
    console.log(image);
    this.mainImage = image.imagePath;
    if (this.mainImage != null) {
      this.mainImageShow = true;
      this.mainImageId = image.imageDetailsId;
    }
    this.newProduct.controls['imageDetails'].setValue(this.imageList);
  }

  onContentChanged(event: any): void {
    this.description = event.html;
    console.log(this.description);
  }

  // Update the color picker when the text input changes
  updateColorPicker(index: number, event: Event) {
    const inputElement = event.target as HTMLInputElement;
    const value = inputElement.value;

    if (/^#[0-9A-F]{6}$/i.test(value)) {  // Validate HEX color
      this.productVariantDetails.controls[index].get('color')?.setValue(value);
    }
  }

  // Update the text input when the color picker changes
  updateColorCode(index: number, event: Event) {
    const inputElement = event.target as HTMLInputElement;
    this.productVariantDetails.controls[index].get('color')?.setValue(inputElement.value);
  }




  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length > 0) {
      const file = input.files[0];

      // Validate file type
      const allowedTypes = ['image/jpeg', 'image/png'];
      if (!allowedTypes.includes(file.type)) {
        this.toastr.error("Only JPG and PNG files are allowed.");
        return;
      }

      // Validate file size (2MB = 2 * 1024 * 1024 bytes)
      const maxSizeInBytes = 2 * 1024 * 1024;
      if (file.size > maxSizeInBytes) {
        this.toastr.error("File size must be below 2MB.");
        return;
      }

      if (this.imageList.length >= 6) {
        this.toastr.error("You can upload a maximum of 6 images.");
        return;
      }

      const reader = new FileReader();
      reader.onload = (e: any) => {
        const img = new Image();
        img.src = e.target.result;
        img.onload = async () => {
          console.log(`Original Size: ${img.width}x${img.height}`);

          // Resize if dimensions are not 600x600
          if (img.width !== 600 || img.height !== 600) {
            // this.toastr.warning("Resizing image to 600x600 pixels.");
            this.resizeImage(img, 600, 600).then((resizedBase64) => {
              this.addImageToList(resizedBase64);
            });
          } else {
            // Image is already 600x600, add it directly
            this.addImageToList(e.target.result);
          }
        };
      };
      reader.readAsDataURL(file);

      input.value = '';
    }
  }

  // Function to resize image using canvas
  resizeImage(image: HTMLImageElement, width: number, height: number): Promise<string> {
    return new Promise((resolve) => {
      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext('2d');

      if (ctx) {
        ctx.drawImage(image, 0, 0, width, height);
        resolve(canvas.toDataURL('image/jpeg', 0.9));
      }
    });
  }

  // Function to add resized image to the image list
  addImageToList(base64String: string) {
    const base64Value = base64String.split(',')[1];
    this.imageList.push({
      imageDetailsId: 0,
      temporaryImagePath: base64String,
      imageData: base64Value,
      referenceId: 0,
      imageName: 'PNG',
      isPrimary: false,
      isActive: false,
      imagePath: '',
      imageType: 'PNG',
      imageFileName: '',
    });

    if (this.imageList.length < 2) {
      this.toastr.info("Please upload at least 2 images.");
    }

    this.newProduct.controls['imageDetails'].setValue(this.imageList);
  }



  removeLocalImage(img: string): void {
    this.imageList = this.imageList.filter(image => image.temporaryImagePath !== img);
    if (this.mainImage === img) {
      this.mainImage = null;
      console.log("Image", this.imageList)
    }
  }

  removeServerImage(img: string): void {
    this.spinner.show();
    const imageList = this.imageList.filter(image => image.imagePath === img);
    if (this.imageList.length > 2) {
      this.appService.deleteImageByAssetId(Number(imageList[0].imageDetailsId))
        .pipe(takeUntil(this.destroy$))
        .subscribe(data => {
          console.log('Image deleted:', data);
          this.imageList = this.imageList.filter(image => image.imagePath != img);
          if (this.mainImage === img) {
            this.mainImage = null;
            console.log("Image", this.imageList)
          }
          this.spinner.hide();
        }, (error: any) => {
          this.spinner.hide();
          this.toastr.error(error.error.msg || "Something went wrong, please try again");
        });
    } else {
      this.spinner.hide();
      this.toastr.error("You can't delete the last image.");
    }

  }


  setMainImage(img: string): void {
    this.mainImage = img;
    console.log("image set", img);
    this.imageList.forEach(image => image.isPrimary = false);
    console.log(this.imageList);

    const localMainImage = this.imageList.find(image => image.temporaryImagePath === img);
    const serverMainImage = this.imageList.find(image => image.imagePath === img);
    if (localMainImage) {
      console.log('Setting local main image', localMainImage);
      localMainImage.isPrimary = true;
      this.mainImageShow = false;
    } else if (serverMainImage) {
      console.log('Setting server main image', serverMainImage);
      this.mainImageId = serverMainImage.imageDetailsId;
      serverMainImage.isPrimary = true;
      this.mainImageShow = true;
    } else {
      console.error('No image found matching the provided path.');
    }
  }


  saveProductDetails() {
    this.spinner.show();
    this.newProduct.controls['categoryId'].setValue(this.currentCategoryId)
    console.log('Saving Product Data:', this.newProduct.value);
    this.appService.saveNewProduct([this.newProduct.value])
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        this.spinner.hide();
        console.log('Product details updated:', data);
        this.saveAlert();
      }, (err: any) => {
        this.spinner.hide();
        this.toastr.error(err.error.msg || "Something went wrong, please try again");
      })
  }

  updateProductDetails() {
    this.spinner.show();
    console.log('Updating Product Data:', this.newProduct.get('imageDetails').value);
    this.newProduct.controls['imageDetails'].setValue([])
    this.newProduct.controls['categoryId'].setValue(this.currentCategoryId)
    this.appService.updateProductDetails(this.newProduct.value)
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        console.log('Product details updated:', data);
        this.updateAssetImage(this.productId, this.imageList)
      }, (err: any) => {
        this.spinner.hide();
        this.toastr.error(err.error.msg || "Something went wrong, please try again");
      })
  }

  updateAssetImage(productId: number, imageListDetails: ImageDetails[]) {
    this.appService.updateProductImage(productId, imageListDetails)
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        this.spinner.hide();
        console.log('Image updated:', data);
        this.toastr.success("Product details updated successfully.");
        this.router.navigate(['/main/product-view']);
      }, (error: any) => {
        this.spinner.hide();
        this.toastr.error(error.error.msg || "Something went wrong, please try again");
      })
  }


  OnlyNumbers($event: KeyboardEvent) {

    let regex: RegExp = new RegExp(/^[0-9.]$/g);
    let specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'ArrowRight', 'ArrowLeft'];

    if (specialKeys.indexOf($event.key) !== -1) {
      return;
    }

    if (regex.test($event.key)) {
      return true;
    } else {
      $event.preventDefault();
      return false;
    }
  }

  saveAlert() {
    Swal.fire({
      title: "Product saved successfully",
      icon: "success",
      draggable: true
    }).then((result) => {
      if (result.isConfirmed) {
        window.location.reload();
      }
    });
  }

  deleteProductVariantDetails(index: number, form: any) {
    this.spinner.show();
    const variantId = form.value.productVariantId
    this.appService.deleteProductVariantDetails(variantId)
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: any) => {
        this.spinner.hide();
        this.productVariantDetails.removeAt(index);
      }, (error: any) => {
        this.spinner.hide();
        this.toastr.error(error.message || "Something went wrong, please try again...")

      })
  }

  ngOnDestroy(): void {
    localStorage.removeItem("productId");
  }

}

